export default __webpack_public_path__ + "0f97897d45ad4253e8bdc49acded458d.svg";